import { render, staticRenderFns } from "./TelefoneCelular.vue?vue&type=template&id=07d168f0"
import script from "./TelefoneCelular.vue?vue&type=script&lang=js"
export * from "./TelefoneCelular.vue?vue&type=script&lang=js"
import style0 from "./TelefoneCelular.vue?vue&type=style&index=0&id=07d168f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports